<section class="et-panel" aria-label="Estado del trámite">
  <!-- Formulario -->
  <div class="download-panel-card" *ngIf="!tieneResultados">
    <div class="download-panel-icon" aria-hidden="true">
      <i class="fas fa-clipboard-list"></i>
    </div>
    <div class="download-panel-copy et-form-block">
      <h2>Estado del trámite</h2>
      <p>
        Ingresa el tipo y número de identificación del solicitante para ver el avance de tus solicitudes.
      </p>

      <form [formGroup]="formaForm" (ngSubmit)="consultar()" class="et-form" novalidate>
        <div class="et-field-grid">
          <div class="et-field">
            <label class="et-label" id="et-tipo-label">Tipo de identificación *</label>
            <app-custom-select
              formControlName="tipo"
              inputId="et-tipo"
              ariaLabelledby="et-tipo-label"
              [options]="tiposDocumentos"
              [invalid]="camposInvalidos('tipo')">
            </app-custom-select>
            <p class="et-err" *ngIf="camposInvalidos('tipo')">Selecciona un tipo de documento.</p>
          </div>

          <div class="et-field">
            <label class="et-label" for="et-numero">Número de identificación *</label>
            <input
              id="et-numero"
              type="text"
              class="et-input"
              formControlName="numero"
              [placeholder]="esNit ? 'Solo 9 dígitos (sin dígito de verificación)' : 'Sin puntos ni comas'"
              autocomplete="off"
              [class.is-invalid]="camposInvalidos('numero')"
              (keyup)="onNumeroKeyup($event)" />
            <p class="et-err" *ngIf="camposInvalidos('numero')">{{ mensajeNumero }}</p>
            <p class="et-err" *ngIf="comas">No uses comas ni punto decimal.</p>
          </div>

          <div class="et-field et-field--dv" *ngIf="esNit">
            <label class="et-label" for="et-dv">Dígito de verificación *</label>
            <input
              id="et-dv"
              type="text"
              class="et-input"
              formControlName="codigo"
              placeholder="0–9"
              maxlength="1"
              inputmode="numeric"
              autocomplete="off"
              [class.is-invalid]="camposInvalidos('codigo')" />
            <p class="et-err" *ngIf="camposInvalidos('codigo')">Dígito de verificación no válido.</p>
          </div>
        </div>

        <p class="et-hint" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>

        <div class="et-actions">
          <button type="submit" class="btn btn-primary" [disabled]="formaForm.invalid || loading">
            <span *ngIf="!loading">Consultar</span>
            <span *ngIf="loading"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Consultando…</span>
          </button>
        </div>
        <p class="et-footnote">* Campos obligatorios</p>
      </form>
    </div>
  </div>

  <!-- Resultados -->
  <div class="et-results-card" *ngIf="tieneResultados">
    <header class="et-results-head">
      <div class="et-results-icon" aria-hidden="true">
        <i class="fas fa-clipboard-check"></i>
      </div>
      <div class="et-results-titles">
        <p class="et-welcome" *ngIf="nombreSaludo">
          Hola, <strong>{{ nombreSaludo }}</strong>.
        </p>
        <h2>
          Solicitudes encontradas
          <span class="et-count">{{ listadoSolicitudes.length }}</span>
        </h2>
        <p *ngIf="tituloConsulta">{{ tituloConsulta }}</p>
      </div>
      <button type="button" class="et-link-btn" (click)="nuevaConsulta()">
        <i class="fas fa-arrow-left" aria-hidden="true"></i>
        Nueva consulta
      </button>
    </header>

    <div class="et-filter" *ngIf="listadoSolicitudes.length > 1">
      <label class="sr-only" for="et-filtro">Buscar en resultados</label>
      <div class="et-filter__wrap">
        <i class="fas fa-search et-filter__icon" aria-hidden="true"></i>
        <input
          id="et-filtro"
          type="search"
          class="et-filter__input"
          [value]="filtroLocal"
          (input)="onFiltroInput($event)"
          placeholder="Buscar por solicitud, orden o política/perfil…"
          autocomplete="off" />
        <button
          type="button"
          class="et-filter__clear"
          *ngIf="hayFiltroActivo"
          (click)="limpiarFiltro()"
          aria-label="Limpiar búsqueda">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <p class="et-filter__meta" *ngIf="hayFiltroActivo">
        {{ listadoFiltrado.length }} de {{ listadoSolicitudes.length }}
        solicitud{{ listadoSolicitudes.length === 1 ? '' : 'es' }}
      </p>
    </div>

    <div
      class="et-list"
      role="region"
      aria-label="Listado de solicitudes"
      [class.et-list--titular-shared]="titularCompartido">
      <p class="et-filter-empty" *ngIf="hayFiltroActivo && !listadoFiltrado.length">
        Ninguna solicitud coincide con “{{ filtroLocal.trim() }}”.
      </p>

      <article
        class="et-row"
        *ngFor="let item of listadoFiltrado"
        [class.is-open]="estaExpandida(item)">
        <button
          type="button"
          class="et-row__head"
          (click)="toggleSolicitud(item)"
          [attr.aria-expanded]="estaExpandida(item)"
          [attr.title]="titularCompartido ? item.nombreTitular : null">
          <span class="et-row__ring" [attr.title]="textoProgreso(item)" aria-hidden="true">
            {{ pasosHechos(item) }}/{{ pasosTotal(item) }}
          </span>

          <span class="et-row__ids">
            <span class="et-code" [attr.title]="'Solicitud ' + item.solicitudId">
              <span class="et-code__k">Sol.</span>{{ item.solicitudId }}
            </span>
            <span class="et-code et-code--muted" [attr.title]="'Orden ' + item.ordenPedidoId">
              <span class="et-code__k">Ord.</span>{{ item.ordenPedidoId }}
            </span>
          </span>

          <span class="et-row__titular" *ngIf="!titularCompartido" [attr.title]="item.nombreTitular">
            {{ item.nombreTitular }}
          </span>

          <span class="et-row__chips">
            <span
              class="et-chip"
              [class.et-chip--soft]="mecanismoCompartido"
              *ngIf="item.mecanismo">{{ item.mecanismo }}</span>
            <span class="et-chip et-chip--muted" *ngIf="item.politica">{{ item.politica }}</span>
          </span>

          <span class="et-row__chevron" aria-hidden="true">
            <i class="fas" [class.fa-chevron-down]="!estaExpandida(item)" [class.fa-chevron-up]="estaExpandida(item)"></i>
          </span>
        </button>

        <div class="et-row__body" *ngIf="estaExpandida(item)">
          <div class="et-timeline" *ngIf="item.pasos?.length; else sinPasos" aria-label="Avance del trámite">
            <ng-container *ngFor="let paso of item.pasos; let i = index; let last = last">
              <div
                class="et-timeline__item"
                [class.is-done]="paso.finalizado"
                [class.is-current]="esPasoActual(item, i)"
                [class.is-pending]="!paso.finalizado && !esPasoActual(item, i)">
                <button
                  type="button"
                  class="et-timeline__btn"
                  [disabled]="!tieneComentarios(paso)"
                  (click)="mostrarComentarios(paso.comentarios); $event.stopPropagation()"
                  [attr.title]="paso.fecha || paso.paso">
                  <span class="et-timeline__num">
                    <i class="fas fa-check" *ngIf="paso.finalizado" aria-hidden="true"></i>
                    <ng-container *ngIf="!paso.finalizado">{{ i + 1 }}</ng-container>
                  </span>
                  <span class="et-timeline__copy">
                    <span class="et-timeline__label">{{ paso.paso }}</span>
                    <span class="et-timeline__fecha" *ngIf="paso.fecha">{{ paso.fecha }}</span>
                  </span>
                  <i class="fas fa-info-circle et-timeline__info" *ngIf="tieneComentarios(paso)" aria-hidden="true"></i>
                </button>
              </div>
              <span
                class="et-timeline__line"
                *ngIf="!last"
                [class.is-done]="paso.finalizado"
                aria-hidden="true"></span>
            </ng-container>
          </div>
          <ng-template #sinPasos>
            <p class="et-empty-pasos">No hay pasos registrados para esta solicitud.</p>
          </ng-template>
        </div>
      </article>
    </div>
  </div>
</section>
